import { BaseParser, DATA_TYPE_EXTERN_PAYLOAD, TYPE_EXTERN_PAYLOAD } from './baseExtractor.js';
import { ExtraConfigKey, NameExtraConfig } from '../commonPlotDefinitions.js'

const iconExtern = 'addFile.png';

class JSONExtractor extends BaseParser {
  async _doParse(parent, fileName, data, report) {
    const returnValue = this.getNewReturnValue();
    const payloadBackEnd = JSON.parse(data);
    returnValue.processedData = payloadBackEnd;
    returnValue.lastError = '';
    returnValue.dataType = DATA_TYPE_EXTERN_PAYLOAD;
    returnValue.type = TYPE_EXTERN_PAYLOAD;
    returnValue.icon = iconExtern;
    returnValue.success = true;
    if(typeof report[ExtraConfigKey] === 'undefined')
      report[ExtraConfigKey] = {}
    report[ExtraConfigKey][NameExtraConfig.ExternPayload] = true;
    return returnValue;
  }
}

export{
  JSONExtractor,
};
